<!--
 * @Description: 登录
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:40:58
 * @LastEditTime: 2022-06-14 09:21:05
-->
<template>
    <Common>
      <template slot="cd">
          <CdhospitalPersonalInfomation />
      </template>
      <template slot="sz">
          <SzhospitalPersonalInfomation />
      </template>
      <template slot="hf">
          <HfhospitalPersonalInfomation />
      </template>
    </Common>
</template>

<script>
import CdhospitalPersonalInfomation from "@/components/hospitalPersonalInfomation/cdPersonalInfomation"
import SzhospitalPersonalInfomation from "@/components/hospitalPersonalInfomation/szPersonalInfomation"
import HfhospitalPersonalInfomation from "@/components/hospitalPersonalInfomation/hfPersonalInfomation"
export default{
  components:{
    CdhospitalPersonalInfomation,
    SzhospitalPersonalInfomation,
    HfhospitalPersonalInfomation
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>

</style>